var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tooltipComponent,{tag:"component",staticClass:"c-swatch",attrs:{"message":_vm.message,"to":_vm.link,"position":"bottom","aria-hidden":"true","role":"button"},nativeOn:{"click":function($event){return _vm.$emit(_vm.eventType, _vm.color)}}},[(_vm.image)?_c('div',{staticClass:"c-swatch__color-image",class:{
      'l-flex': true,
      'c-swatch__color-image--active' : _vm.active
    }},[_c('div',{staticClass:"c-swatch__color-middle",class:{
        'c-swatch__color-middle--active': _vm.active,
        'c-swatch__color-middle--diamond': _vm.needsBorder
      },style:(_vm.image)})]):(_vm.hue.length)?_c('div',{staticClass:"c-swatch__color-image",class:{
      'l-flex': true,
      'c-swatch__color-image--active': _vm.active
    }},[_c('div',{staticClass:"c-swatch__color-middle",class:{
        'c-swatch__color-middle--active': _vm.active,
        'c-swatch__color-middle--white': _vm.needsBorder
      },style:(_vm.image)})]):(_vm.finish && _vm.finish.title)?_c('div',{staticClass:"c-swatch__finish",class:{'c-swatch__finish--active': _vm.finish.active}},[_c('div',{staticClass:"c-swatch__finish-middle",class:{
        'c-swatch__finish-middle--white': _vm.needsBorder
      }}),_vm._v("\n    "+_vm._s(_vm.finish.finish)+"\n  ")]):_c('div',{staticClass:"c-swatch__color-image",class:{
      'l-flex': true,
      'c-swatch__color-image--active' : _vm.active
    }},[_c('div',{staticClass:"c-swatch__color-middle",class:{
        'c-swatch__color-middle--active': _vm.active,
        'c-swatch__color-middle--diamond': _vm.needsBorder
      },style:(_vm.image)})]),_vm._v(" "),(_vm.showLabel)?_c('div',{staticClass:"c-swatch__label",class:[
      'u-center-text'
    ]},[_vm._v("\n    "+_vm._s(_vm.color.name)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }